export default __webpack_public_path__ + "static/media/Change password.336879cf.svg";